/* eslint-disable no-unused-vars */
import { IGetApiRequestParams, ILooseObject } from '@/src/types/common.interface';
import AppUtils from '@/src/utils/AppUtils';

export enum ALL_APP_LEVEL_CREDENTIALS_URLS_ENUM {
  GET_ALL_APP_LEVEL_CREDENTIALS_LIST = 'GET_ALL_APP_LEVEL_CREDENTIALS_LIST',
  CREATE_NEW_APP_LEVEL_CREDENTIALS = 'CREATE_NEW_APP_LEVEL_CREDENTIALS',
  GET_ROLES_BY_DESTINATION_APPLICATION = 'GET_ROLES_BY_DESTINATION_APPLICATION',
  GET_ALL_APPLICATION_LIST = 'GET_ALL_APPLICATION_LIST'
}

type GET_APP_LEVEL_CREDENTIALS_API_URL_TYPE = IGetApiRequestParams & {
  url: ALL_APP_LEVEL_CREDENTIALS_URLS_ENUM;
  data?: ILooseObject;
};

abstract class AllAppLevelCredentials {
  public static getAllAppLevelCredentialsApiUrl({
    url,
    filters
  }: GET_APP_LEVEL_CREDENTIALS_API_URL_TYPE) {
    switch (url) {
      case ALL_APP_LEVEL_CREDENTIALS_URLS_ENUM.GET_ALL_APP_LEVEL_CREDENTIALS_LIST:
        return AppUtils.formatGetApiParameters(
          `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/api_key`,
          { filters }
        );
      case ALL_APP_LEVEL_CREDENTIALS_URLS_ENUM.CREATE_NEW_APP_LEVEL_CREDENTIALS:
        return `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/api_key`;

      case ALL_APP_LEVEL_CREDENTIALS_URLS_ENUM.GET_ROLES_BY_DESTINATION_APPLICATION:
        return AppUtils.formatGetApiParameters(
          `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/roles`,
          { filters }
        );

      case ALL_APP_LEVEL_CREDENTIALS_URLS_ENUM.GET_ALL_APPLICATION_LIST:
        return `${process.env.REACT_APP_CENTRAL_AUTH_API_BASE_URL}/v1/applications`;
      default:
        return '';
    }
  }
}

export default AllAppLevelCredentials;
